// Home.jsx (معدل مع إمكانية تغيير رقم الواتساب)
import React, { useEffect, useState } from "react";
import "./Home.css";
import { 
  FaBullhorn, FaClipboardList, FaLaptopCode, FaStethoscope, 
  FaCalendarCheck, FaChartLine, FaCogs, FaHeadset, FaPaintBrush,
  FaExternalLinkAlt, FaHospital, FaChartBar,
  FaDatabase, 
} from "react-icons/fa";

// ✅ استيراد الصورة من مجلد assets
import whatsappBotImage from "../assets/robot.png";

const Home = () => {
  const [lang, setLang] = useState("ar");

  const images = [
    "https://plus.unsplash.com/premium_photo-1681843129112-f7d11a2f17e3?q=80&w=870&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1762237798221-a298c91e18a3?q=80&w=564&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
    "https://images.unsplash.com/photo-1579684385127-1ef15d508118?q=80&w=580&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D",
  ];
  
  const [current, setCurrent] = useState(0);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [images.length]);

  const translations = {
    heroTitle: { ar: "حلول طبية متقدمة لعملك", en: "Advanced Medical Solutions for Your Business" },
    heroDescription: { ar: "نُمكّن مقدمي الرعاية الصحية من تقديم خدمات متميزة من خلال أحدث التقنيات والأنظمة الذكية", en: "We empower healthcare providers to deliver exceptional services using the latest technologies and smart systems" },
    ourServicesBtn: { ar: "خدماتنا", en: "Our Services" },
    servicesTitle: { ar: "خدماتنا المميزة", en: "Our Featured Services" },
    services: {
      ar: [
        { title: "تسويق رقمي طبي", description: "حملات إعلانية للوصول لمرضى جدد" },
        { title: "حلول إدارة الحجوزات", description: "إدارة الحجوزات والمرضى بسهولة" },
        { title: "تطوير مواقع احترافية", description: "تصميم وبرمجة مواقع لعياداتك" },
        { title: "استشارات طبية", description: "منصة متكاملة للاستشارات بالفيديو" },
        { title: "نظام مواعيد ذكي", description: "جدولة ذكية مع تنبيهات آلية" },
        { title: "تحليلات طبية متقدمة", description: "ذكاء اصطناعي لتحسين الأداء" }
      ],
      en: [
        { title: "Medical Digital Marketing", description: "Advertising campaigns to reach new patients" },
        { title: "Appointment Management Solutions", description: "Easy management of bookings and patients" },
        { title: "Professional Website Development", description: "Design and code websites for your clinics" },
        { title: "Medical Consultations", description: "Integrated platform for video consultations" },
        { title: "Smart Scheduling System", description: "Smart scheduling with automatic reminders" },
        { title: "Advanced Medical Analytics", description: "AI to improve performance" }
      ]
    },
    whyTitle: { ar: "ليه تختارنا", en: "Why Choose Us" },
    whyItems: {
      ar: [
        { title: "حلول مخصصة", description: "نقدم حلول حسب متطلباتك" },
        { title: "دعم فني مستمر", description: "فريق دعم جاهز 24/7" },
        { title: "تصميم احترافي", description: "تصميم سريع وجذاب" },
        { title: "خبرة طبية", description: "خبرة واسعة في المجال الطبي" }
      ],
      en: [
        { title: "Custom Solutions", description: "We provide solutions tailored to your needs" },
        { title: "Continuous Technical Support", description: "Support team ready 24/7" },
        { title: "Professional Design", description: "Fast and attractive design" },
        { title: "Medical Expertise", description: "Extensive experience in the medical field" }
      ]
    },
    portfolioTitle: { ar: "نماذج أعمالنا", en: "Our Work Samples" },
    portfolioSubtitle: { ar: "نقدم حلولاً رقمية مبتكرة للمؤسسات الطبية، شاهد نماذج من أعمالنا المتميزة", en: "We provide innovative digital solutions for medical institutions. See samples of our distinguished work" },
    categories: {
      ar: [
        { id: "all", name: "الكل" },
        { id: "تحليلات", name: "تحليلات" },
        { id: "تقارير", name: "تقارير" },
        { id: "مواقع", name: "مواقع" },
        { id: "لوحات تحكم", name: "لوحات تحكم" }
      ],
      en: [
        { id: "all", name: "All" },
        { id: "تحليلات", name: "Analytics" },
        { id: "تقارير", name: "Reports" },
        { id: "مواقع", name: "Websites" },
        { id: "لوحات تحكم", name: "Dashboards" }
      ]
    },
    viewAllBtn: { ar: "شوف كل الأعمال", en: "View All Works" },
    projects: {
      ar: [
        { title: "نظام تحليلات البيانات", category: "تحليلات", description: "لوحة تحكم متقدمة لتحليل أداء العيادات والمستشفيات مع تقارير لحظية", tags: ["البرمجه والتطوير"] },
        { title: "بوابة التقارير الطبية", category: "تقارير", description: "نظام متكامل لإدارة وتوليد التقارير الطبية والإحصاءات الدقيقة", tags: ["البرمجه والتطوير"] },
        { title: "نظام إدارة المحتوى", category: "مواقع", description: "موقع إلكتروني متكامل لإدارة المحتوى الطبي والخدمات", tags: ["البرمجه والتطوير"] },
        { title: "لوحة تحكم المستشفى", category: "لوحات تحكم", description: "نظام إدارة متكامل مع لوحات تحكم تفاعلية وتقارير فورية", tags: ["البرمجه والتطوير"] },
        { title: "موقع عيادة متخصصة", category: "مواقع", description: "موقع احترافي لعيادة طبية مع نظام حجز إلكتروني", tags: ["البرمجه والتطوير"] },
        { title: "نظام تحليل الأداء", category: "تحليلات", description: "تحليل أداء الأطباء والمرضى مع تقارير متقدمة", tags: ["البرمجه والتطوير"] },
        { title: "بوابة التقارير الذكية", category: "تقارير", description: "تقارير آلية ذكية مع إشعارات وتنبيهات فورية", tags: ["البرمجه والتطوير"] },
        { title: "منصة الخدمات الطبية", category: "مواقع", description: "موقع شامل للخدمات الطبية مع نظام استشارات عن بعد", tags: ["البرمجه والتطوير"] }
      ],
      en: [
        { title: "Data Analytics System", category: "تحليلات", description: "Advanced dashboard for analyzing clinic and hospital performance with real-time reports", tags: ["Programming & Development"] },
        { title: "Medical Reports Portal", category: "تقارير", description: "Integrated system for managing and generating medical reports and accurate statistics", tags: ["Programming & Development"] },
        { title: "Content Management System", category: "مواقع", description: "Comprehensive website for managing medical content and services", tags: ["Programming & Development"] },
        { title: "Hospital Dashboard", category: "لوحات تحكم", description: "Integrated management system with interactive dashboards and instant reports", tags: ["Programming & Development"] },
        { title: "Specialized Clinic Website", category: "مواقع", description: "Professional website for a medical clinic with an electronic booking system", tags: ["Programming & Development"] },
        { title: "Performance Analysis System", category: "تحليلات", description: "Analysis of doctor and patient performance with advanced reports", tags: ["Programming & Development"] },
        { title: "Smart Reports Portal", category: "تقارير", description: "Automated smart reports with instant notifications and alerts", tags: ["Programming & Development"] },
        { title: "Medical Services Platform", category: "مواقع", description: "Comprehensive medical services website with a teleconsultation system", tags: ["Programming & Development"] }
      ]
    },
    whatsappTooltip: { ar: "تواصل مع البوت", en: "Contact Bot" }
  };

  const t = translations;
  const currentLang = lang;

  const services = [
    { id: 1, icon: <FaBullhorn />, color: "#0E74AB" },
    { id: 2, icon: <FaClipboardList />, color: "#0E74AB" },
    { id: 3, icon: <FaLaptopCode />, color: "#0E74AB" },
    { id: 4, icon: <FaStethoscope />, color: "#0E74AB" },
    { id: 5, icon: <FaCalendarCheck />, color: "#0E74AB" },
    { id: 6, icon: <FaChartLine />, color: "#0E74AB" }
  ];

  const whyChooseUsIcons = [
    { id: 1, icon: <FaCogs />, color: "#0E74AB" },
    { id: 2, icon: <FaHeadset />, color: "#0E74AB" },
    { id: 3, icon: <FaPaintBrush />, color: "#0E74AB" },
    { id: 4, icon: <FaStethoscope />, color: "#0E74AB" }
  ];

  const projects = [
    { id: 1, image: "https://plus.unsplash.com/premium_photo-1726848121953-354d20f7f522?q=80&w=802&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D", icon: <FaChartBar /> },
    { id: 2, image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop", icon: <FaDatabase /> },
    { id: 3, image: "https://images.unsplash.com/photo-1547658719-da2b51169166?q=80&w=1600&auto=format&fit=crop", icon: <FaLaptopCode /> },
    { id: 4, image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=1600&auto=format&fit=crop", icon: <FaChartBar /> },
    { id: 5, image: "https://media.istockphoto.com/id/1463017783/photo/online-payment-platform-for-modish-money-transfer.jpg?s=1024x1024&w=is&k=20&c=z6b0NyN8qiRDS1BHVQw7HU-24Ii6mFSqtpv2an_jGqQ=", icon: <FaHospital /> },
    { id: 6, image: "https://media.istockphoto.com/id/2185857328/photo/businessman-is-using-a-pen-to-write-data-analysis.jpg?s=1024x1024&w=is&k=20&c=-FCogu0v4PmYWpNihCzrCtEwYZUb1ZQYzFO49c_IbIo=", icon: <FaChartLine /> },
    { id: 7, image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?q=80&w=1600&auto=format&fit=crop", icon: <FaDatabase /> },
    { id: 8, image: "https://media.istockphoto.com/id/628612368/photo/human-hand-touching-medical-button-on-screen.jpg?s=1024x1024&w=is&k=20&c=Xn4_EFDtYS6MvIMo3sFnQE2dPCJZimPqENJO81TVeHE=", icon: <FaStethoscope /> }
  ];

  const projectsData = projects.map((proj, idx) => ({
    ...proj,
    title: t.projects[currentLang][idx].title,
    category: t.projects[currentLang][idx].category,
    description: t.projects[currentLang][idx].description,
    tags: t.projects[currentLang][idx].tags
  }));

  const categories = t.categories[currentLang];
  const filteredProjects = filter === "all" ? projectsData : projectsData.filter(p => p.category === filter);

  const handleOurServices = () => {
    alert(currentLang === "ar" ? "جاري تحميل خدماتنا المميزة..." : "Loading our featured services...");
    const servicesSection = document.querySelector('.services-section');
    if (servicesSection) servicesSection.scrollIntoView({ behavior: 'smooth' });
  };

  // ✅ مكان تغيير رقم الواتساب - استبدل الرقم التالي بالرقم المطلوب
  const WHATSAPP_NUMBER = "+201037334294";  // غيّر هذا الرقم إلى ما تريد

  const handleWhatsAppClick = () => {
    window.open(`https://wa.me/${WHATSAPP_NUMBER}`, "_blank");
  };

  const handleViewAllProjects = () => {
    alert(currentLang === "ar" ? "سيتم عرض جميع المشاريع قريباً" : "All projects will be shown soon");
    setFilter("all");
  };

  const handleServiceClick = (serviceTitle) => {
    alert(`${currentLang === "ar" ? "جاري تحميل صفحة خدمة:" : "Loading service page:"} ${serviceTitle}`);
  };

  const handleWhyChooseUsClick = (itemTitle) => {
    alert(`${currentLang === "ar" ? "معلومات عن:" : "Information about:"} ${itemTitle}`);
  };

  const LangSwitcher = () => (
    <button onClick={() => setLang(lang === "ar" ? "en" : "ar")} style={{ position: "fixed", top: "85px", right: "20px", zIndex: 1000, background: "#1E6F8E", color: "white", border: "none", borderRadius: "40px", padding: "8px 16px", fontWeight: "bold", cursor: "pointer", transition: "all 0.3s ease", fontFamily: "inherit", boxShadow: "0 2px 8px rgba(0,0,0,0.2)" }}>
      {lang === "ar" ? "English" : "العربية"}
    </button>
  );

  return (
    <div className="home-container" dir={lang === "ar" ? "rtl" : "ltr"}>
      {/* LangSwitcher Removed */}

      <section className="hero-section">
        <div className="hero-slider">
          {images.map((img, index) => (
            <img key={index} src={img} alt={`Medical ${index + 1}`} className={index === current ? "active" : ""} />
          ))}
        </div>
        <div className="hero-overlay">
          <h1><span>{t.heroTitle[lang]}</span></h1>
          <p>{t.heroDescription[lang]}</p>
          <div className="hero-buttons">
            <button className="btn-secondary" onClick={handleOurServices}>{t.ourServicesBtn[lang]}</button>
          </div>
        </div>
      </section>

      <section className="services-section">
        <h2 className="services-title">{t.servicesTitle[lang]}</h2>
        <div className="services-grid">
          {services.map((service, idx) => (
            <div key={service.id} className="service-card" onClick={() => handleServiceClick(t.services[lang][idx].title)}>
              <div style={{ color: service.color }}>{service.icon}</div>
              <h3>{t.services[lang][idx].title}</h3>
              <p>{t.services[lang][idx].description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="why-section">
        <h2 className="why-title">{t.whyTitle[lang]}</h2>
        <div className="why-grid">
          {whyChooseUsIcons.map((item, idx) => (
            <div key={item.id} className="why-card" onClick={() => handleWhyChooseUsClick(t.whyItems[lang][idx].title)}>
              <div style={{ color: item.color }}>{item.icon}</div>
              <h3>{t.whyItems[lang][idx].title}</h3>
              <p>{t.whyItems[lang][idx].description}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="portfolio-section">
        <div className="portfolio-header">
          <h2 className="portfolio-title">{t.portfolioTitle[lang]}</h2>
          <p className="portfolio-subtitle">{t.portfolioSubtitle[lang]}</p>
        </div>
        <div className="portfolio-filters">
          {categories.map((cat) => (
            <button key={cat.id} className={`filter-btn ${filter === cat.id ? "active" : ""}`} onClick={() => setFilter(cat.id)}>
              {cat.name}
            </button>
          ))}
        </div>
        <div className="portfolio-grid">
          {filteredProjects.map((project) => (
            <div key={project.id} className="portfolio-card">
              <div className="card-image"><img src={project.image} alt={project.title} /></div>
              <div className="card-content">
                <div className="card-header"><div className="card-icon">{project.icon}</div><h3 className="card-title">{project.title}</h3></div>
                <p className="card-description">{project.description}</p>
                <div className="card-tags">{project.tags.map((tag, idx) => <span key={idx} className="tag">{tag}</span>)}</div>
                <div className="card-footer"><span className="project-category">{project.category}</span></div>
              </div>
            </div>
          ))}
        </div>
        <div className="view-all">
          <button className="view-all-btn" onClick={handleViewAllProjects}>{t.viewAllBtn[lang]} <FaExternalLinkAlt /></button>
        </div>
      </section>

      <div className="whatsapp-float" onClick={handleWhatsAppClick}>
        <img src={whatsappBotImage} alt="WhatsApp Bot" style={{ width: "50px", height: "50px", borderRadius: "50%", objectFit: "cover" }} />
        <div className="whatsapp-tooltip">{t.whatsappTooltip[lang]}</div>
      </div>
    </div>
  );
};

export default Home;